import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { environment } from '@environments/environment';
import { AccountService, ConnectionStatusService } from '@app/_services';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

  constructor(
    private accountService: AccountService,
    private connectionStatus: ConnectionStatusService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const user = this.accountService.userValue;
    const isLoggedIn = user && user.token; //null user should make this false, in case customize
    const isApiUrl = request.url.startsWith(environment.apiURL);

    //check if this is ok with headers set in environment and used in other services (promo)
    if(isLoggedIn && isApiUrl){
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${user!.token}`
        }
      });
      // if it is logged in, user must be non null
    }

    return next.handle(request).pipe(
      tap({
        next: (event) => {
          // Mark server as reachable when we get a successful response
          if (event instanceof HttpResponse && isApiUrl) {
            this.connectionStatus.markServerReachable();
          }
        }
      })
    );
  }
}
